import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable, throwError, of } from 'rxjs';
import { retry, catchError, map, tap } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';
import { Booking } from './addbooking/booking.interface';
import { WhCsvBooking } from './importbookings/whbooking.interface';
import * as moment from "moment";
import { ConnoteDocuments,Rate } from 'src/app/model/connotedocuments.model';
import { Url, User } from '../../model/users.model';
import { NotificationsSettingsService } from '../../services/notificationssettings.service';
import { environment } from '../../../environments/environment';
import { DispatchService } from 'src/app/services/dispatch.service';

@Injectable()
export class BookingsService {
    @LocalStorage() url: Url;
    @LocalStorage() user: User;
    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    constructor(public http:HttpClient, private svc_notif_settings: NotificationsSettingsService,  private dispatchService: DispatchService) {
    }

    
    getAddBookingData(): Observable<any> {
        return this.http.get<any>(this.url.rest + '/tms/getAddBookingData', this.httpOptions)
            .pipe(
                tap(() => {
                    // Update the dispatch service's service types
                    this.dispatchService.getDispatchMiscData().subscribe();
                }),
                retry(1),
                catchError(this.handleError)
            );
    }

    getAddBookingData2(): Observable<any> {
        return this.http.get<any>(this.url.rest + '/tms/getAddBookingData2', this.httpOptions)
            .pipe(
                tap(() => {
                    // Update the dispatch service's service types
                    this.dispatchService.getDispatchMiscData().subscribe();
                }),
                retry(1),
                catchError(this.handleError)
            );
    }

    getEditBookingData($id): Observable<Booking> {
        var postData = {'id': $id}
        return this.http.post<Booking>(this.url.rest + '/tms/getEditBookingData', postData, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    getRebookingData($id): Observable<Booking> {
        return this.http.post<Booking>(this.url.rest + '/tms/getRebookingData', $id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    getImportCsvData(): Observable<any> {
        return this.http.get<any>(this.url.rest + '/tms/getImportCsvData', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    saveBooking(booking:Booking): Observable<Booking> {	
    	return this.http.post<Booking>(this.url.rest + '/tms/saveBooking', booking , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    dispatch(connoteId:number, has_tba:boolean, route_id): Observable<any> {	
        var data = {connote_id:connoteId, trigger:'booking', has_tba: has_tba, route_id: route_id}
    	return this.http.post<any>(this.url.rest + '/tms/saveAndDispatch', data , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    updateBooking(booking:Booking): Observable<Booking> {
        return this.http.put<Booking>(this.url.rest + '/tms/updateBooking', booking , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    updateRefNo(data): Observable<Booking> {
        return this.http.put<Booking>(this.url.rest + '/tms/updateRefNo', data , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    updateConnoteSites(data): Observable<Booking> {
        return this.http.post<Booking>(this.url.rest + '/tms/updateConnoteSites', data , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getConnotes(statusFilter = '', dateFilter = '', start = '', end = ''): Observable<any> {
        var param = '';
        if (statusFilter) {
            param = '/' + statusFilter;
            if (dateFilter) {
                param = param + '/' + dateFilter;
                if (dateFilter == 'range') {
                    if (moment(end).isSameOrAfter(moment(start))) {
                        param = param + '/' + start + '/' + end; 
                    }
                } 
            }

        }
        console.log("start", start, "end", end);

        //-> to include "param" in the request
        return this.http.get<any>(this.url.rest + '/tms/getConnotes' + param, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    getConnoteDetails(id: number): Observable<any> {
        return this.http.get<any>(this.url.rest + '/tms/getConnoteDetails/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );


    }

    getCustomerSelection(): Observable<any> {
        return this.http.get<any>(this.url.rest + '/tms/getCustomerSelection', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }
    
    //Connote Notes
    getConnoteNotes(id: number): Observable<any[]> {
        return this.http.get<any[]>(this.url.rest + '/tms/getConnoteNotes/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    createConnoteNote(note: any): Observable<any> {
        return this.http.post<any>(this.url.rest + '/tms/createConnoteNote', note, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    updateConnoteNote(note: any): Observable<any> {
        return this.http.post<any>(this.url.rest + '/tms/updateConnoteNote', note, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    deleteConnoteNote(id: number): Observable<any[]> {
        return this.http.delete<any[]>(this.url.rest + '/tms/deleteConnoteNote/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    //Admin Uploads
    createAdminUpload(connoteDocuments) {
        return this.http.post<ConnoteDocuments>(this.url.rest + '/tms/createAdminUpload', connoteDocuments, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    deleteJobFile(jobFile) {
        return this.http.delete(this.url.rest + '/tms/deleteJobFile/' + jobFile)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }
    
    createConnoteFile(bookingId: number): Observable<number> {
        return this.http.post<number>(this.url.rest + '/tms/createConnote?booking_id=' + bookingId, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    getConnoteFilename(connote_id: number, document_type_id :number): Observable<any> {
        var cdoc = {document_type_id:document_type_id, connote_id:connote_id};

        return this.http.post<any[]>(this.url.rest + '/tms/getConnoteDocumentFilename' , cdoc , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    createPackagingLabel(bookingId: number): Observable<number> {
        return this.http.post<number>(this.url.rest + '/tms/createPackagingLabel?booking_id=' + bookingId, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    updateConnoteFile(bookingId: number): Observable<number> {
        return this.http.post<number>(this.url.rest + '/tms/updateConnote?booking_id=' + bookingId, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    generateConnotesDoc(connoteId:any): Observable<number> {
        const docs = {connote_id:connoteId}
        return this.http.post<any>(this.url.rest + '/tms/generateConnotesDoc', docs, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    generateProcessingConnotesDoc(connoteId:any,run_id:any): Observable<number> {
        const docs = {connote_id:connoteId,user_id:this.user.id, run_id:run_id}
        return this.http.post<any>(this.url.rest + '/tms/generateProcessingConnotesDoc', docs, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    generateLocalStartConnote(connoteId:any,run_id:any): Observable<number> {
        const docs = {connote_id:connoteId,user_id:this.user.id, run_id:run_id}
        return this.http.post<any>(this.url.rest + '/api/generateLocalStartConnote', docs, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    sendBookingMail(bookingId: number): Observable<any[]> {
        const params = {booking_id: bookingId};
        return this.http.post<any[]>(this.url.rest + '/tms/sendBookingMail', params, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }
    
    bulkMarkForInvoice(jobs, user_id): Observable<any[]> {
        return this.http.post<any[]>(this.url.rest  + '/tms/bulkMarkForInvoice/' + user_id, jobs,  this.httpOptions)
            .pipe(
            retry(1),
            catchError(this.handleError)
        )    
    }

    cancelJob(job_id: number): Observable<any[]> {
        return this.http.post<any[]>(this.url.rest  + '/tms/cancelJob/' + job_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    getCustomerRates(id: number): Observable<any> {
        return this.http.get<any>(this.url.rest + '/tms/getCustomerDefaultRatesByCustomer/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );


    }

    markForInvoicing(connote_id: number, user_id: number): Observable<any[]> {
        return this.http.get<any>(this.url.rest + '/tms/markJobForInvoicing/' + connote_id + '/' + user_id ,  this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    updateRate(rate: Rate): Observable<any> {
        return this.http.post<Rate>(this.url.rest + '/tms/updateRate', rate, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    getKlmsHrsPerCoordinates(coordinates:any): Observable<any> {
        return this.http.post<any>(this.url.rest + '/tms/getTotalKlmsHrsByCoordinates', coordinates, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    updateSpecialInstructions(instructions:string, connote_id :number): Observable<any> {
        var data = {connote_id:connote_id, special_instructions:instructions};
        return this.http.post<any>(this.url.rest + '/tms/updateSpecialInstructions', data, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }


    private extractData(res: Response) {
    	let body = res.json();
    	console.log(body);
	    if(body)
            return body || {};
        else
            return null;
    }


    saveWhCsvBooking(bookings:WhCsvBooking[]): Observable<WhCsvBooking[]> {	
    	return this.http.post<WhCsvBooking[]>(this.url.rest + '/tms/saveWhCsvBooking', bookings , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    getLocationRecord(latitude, longtitude): any {
        var coordinates = {lat:latitude, lng:longtitude};
        return this.http.post<any>(this.url.rest + '/tms/getLocationRecord', coordinates, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    getConnoteFiles(connote_id): any {
        return this.http.get<any>(this.url.rest + '/tms/getConnoteFiles/' + connote_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}